import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';

import {RQGetAllHomeImagesAPI} from '../../../reactQuery/apis';

const OverlayTile = ({img, title, link}) => (
  <Link
    to={link}
    className={'relative group w-full h-full block overflow-hidden cursor-pointer rounded-lg'}
  >
    {img && (
      <img
        src={img}
        alt={title}
        className={'w-full h-full object-cover'}
      />
    )}
    <div className={'absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-60 transition duration-300 flex items-center justify-center'}>
      <span className={'text-white text-sm sm:text-xl font-semibold tracking-widest text-center px-2'}>
        {title}
      </span>
    </div>
  </Link>

);

OverlayTile.propTypes = {
  img: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

const TemplateLayoutScreen = () => {
  const {data = [], isLoading} = RQGetAllHomeImagesAPI();
  const [exploreTiles, setExploreTiles] = useState([]);
  const [middleImage, setMiddleImage] = useState('');

  useEffect(() => {
    if (isLoading || !data.length) {return;}

    const exploreSection = data
      .filter(item => item.isActive)
      .find(item => item.carouselImages?.length);

    if (!exploreSection) {return;}

    const carousel = exploreSection.carouselImages || [];
    
    const getImage = pos =>
      carousel.find(c => c.position === pos)?.imageUrl ||
      '/placeholder.jpg';

    setExploreTiles([
      {id: 1, img: getImage(1), title: 'Explore More', link: '/product'}, 
      {id: 2, img: getImage(2), title: 'Explore More', link: '/product'}, 
      {id: 3, img: getImage(3), title: 'Explore More', link: '/product'}, 
      {id: 4, img: getImage(4), title: 'Explore More', link: '/product'}, 
      {id: 5, img: getImage(5), title: 'Explore More', link: '/product'}, 
    ]);

    setMiddleImage(exploreSection.middleImage || '/placeholder.jpg');
  }, [data, isLoading]);

  if (!exploreTiles.length) {return null;}

  return (
    <div className={'w-full overflow-x-hidden flex flex-col justify-center items-center py-5 px-3 sm:px-4'}>
      <h1 className={'title'}>Explore More</h1>

      <div className={'section w-full max-w-screen-xl grid grid-cols-1 lg:grid-cols-5 gap-3'}>
        
        <div className={'lg:col-span-3 grid gap-3'}>
          
          <div 
            data-aos={'fade-right'}
            data-aos-duration={'900'}
            data-aos-easing={'ease-out-cubic'}
            className={'aspect-[16/9] lg:aspect-[3/2]'}>
            <OverlayTile {...exploreTiles[0]} />
          </div>
          
          <div data-aos={'fade-up'} className={'grid grid-cols-3 gap-3'}>
            {[exploreTiles[2], exploreTiles[3], exploreTiles[4]].map(tile => (
              <div key={tile.id} className={'aspect-square'}>
                <OverlayTile {...tile} />
              </div>
            ))}
          </div>
        </div>
        
        <div data-aos={'fade-left'}
          data-aos-duration={'900'}
          data-aos-easing={'ease-out-cubic'} 
          className={'lg:col-span-2'}>
          <div className={'aspect-[2/3] h-full'}>
            <OverlayTile {...exploreTiles[1]} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateLayoutScreen;
